import React from 'react'
import {
  AccordionButton as ChakraAccordionButton,
  AccordionButtonProps,
} from '@chakra-ui/react'

export const AccordionButton: React.FC<
  Pick<AccordionButtonProps, 'as' | 'sx' | 'children'>
> = props => <ChakraAccordionButton {...props} />
